$(document).ready( function() {
    $('.financing.button').on('click', function() {
        $('#open-popup-financing').addClass('open')
    })
})